import { z } from 'zod';
const nonEmptyStringSchema = z.string().trim().min(1);
const timestampSchema = z.string().trim().min(1);
const nonNegativeIntSchema = z.number().int().min(0);
export const mappingsSearchSchema = z.object({
    page: z.coerce.number().int().positive().optional().default(1),
    pageSize: z.coerce.number().int().positive().max(100).optional().default(25),
    status: z.enum(['pending', 'dismissed', 'approved']).optional().default('pending'),
    minScore: z.coerce.number().int().min(0).max(10000).optional(),
    competitionCode: nonEmptyStringSchema.optional(),
    season: z.coerce.number().int().positive().optional(),
});
export const matchingSignalsSchema = z.object({
    timeDifferenceHours: z.number(),
    homeTeamSimilarity: z.number(),
    awayTeamSimilarity: z.number(),
    competitionMatch: z.boolean(),
});
export const fixtureCandidateRowSchema = z.object({
    id: nonEmptyStringSchema,
    polymarketEventId: nonEmptyStringSchema,
    polymarketEventTitle: nonEmptyStringSchema,
    polymarketEventStartTime: timestampSchema.nullable(),
    polymarketHomeTeam: z.string().nullable(),
    polymarketAwayTeam: z.string().nullable(),
    footballFixtureId: nonEmptyStringSchema,
    apiSportsFixtureId: nonNegativeIntSchema,
    footballHomeTeam: nonEmptyStringSchema,
    footballAwayTeam: nonEmptyStringSchema,
    footballFixtureStartTime: timestampSchema,
    confidenceScore: nonNegativeIntSchema, // bps (0-10000)
    matchingSignals: matchingSignalsSchema,
    status: z.enum(['pending', 'dismissed', 'approved']),
    reviewedAt: timestampSchema.nullable(),
    createdAt: timestampSchema,
});
export const fixtureCandidatesListResponseSchema = z.object({
    items: z.array(fixtureCandidateRowSchema),
    pagination: z.object({
        page: z.number().int().positive(),
        pageSize: z.number().int().positive(),
        total: nonNegativeIntSchema,
        totalPages: nonNegativeIntSchema,
    }),
});
export const batchActionSchema = z.object({
    candidateIds: z.array(z.string().trim().min(1)).min(1),
    action: z.enum(['approve', 'dismiss']),
    competitionCode: nonEmptyStringSchema,
    season: z.number().int().positive(),
});
export const undoActionSchema = z.object({
    candidateIds: z.array(z.string().trim().min(1)).min(1),
    action: z.enum(['approve', 'dismiss']),
    competitionCode: nonEmptyStringSchema,
    season: z.number().int().positive(),
});
